class RefreshWPMLMetaBox {

	constructor(wpData, ajaxurl) {
		this.wpData = wpData;
		this.lastIsSaving = false;
		this.ajaxurl = ajaxurl;
		this.metaboxRendered = false;
	}

	addHooks() {
		this.wpData.subscribe(() => this.refreshMetaBox());
	}

	refreshMetaBox() {
		const isSaving = this.wpData.select('core/edit-post').isSavingMetaBoxes(),
			WPMLMetaBox = 'icl_div';

		if (!this.metaboxRendered && isSaving !== this.lastIsSaving && !isSaving) {
			this.lastIsSaving = isSaving;
			fetch(
				this.ajaxurl,
				{
					method: 'POST',
					body: `post_id=${document.getElementById('post_ID').value}&action=wpml_get_meta_boxes_html&nonce=${ document.getElementById('icl_document_language_dropdown').getAttribute('data-metabox-refresh-nonce')}`,
					headers: {
						'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8'
					},
					credentials: 'same-origin'
				}
			)
				.then(response => {
					if ( response.ok ) {
						return response.text();
					}
					throw new Error('Invalid Request');
				})
				.catch(function(error){
					console.log('There has been a problem with your fetch operation: ', error.message);
				})
				.then(html => {
					const metaBoxItems = Array.from(document.getElementById(WPMLMetaBox).children);
					metaBoxItems.forEach((item, index) => {
						if (item.classList.contains('inside')) {
							document.getElementById(WPMLMetaBox).children[index].innerHTML = html;
						}
					});
					this.metaboxRendered = true;
				})
		}

		this.lastIsSaving = isSaving;
	}
}

export default RefreshWPMLMetaBox;


// WEBPACK FOOTER //
// ./js/wpml-meta-box/RefreshWPMLMetaBox.js